import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";
import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";

export default {


  helmet : '',
  desc:'RTLS(Real-time Location Systems)というリアルタイム位置測位システムにより、無線通信、RFID(Radio Frequency Identification)、GPS(Global Positioning System)、BLE、UWBなど様々な技術を活用して開発された位置測位技術です。',
  keywords:'RTLS、位置測位、室内の位置測位、UWB、BLE、GPS、RFID、SmartDevice、建設現場、安全管理、医療装備の測位、物流測位、資産管理、訪問客の測位、訪問客の管理',

  ogTitle:'',
  ogDesc:'',
  ogSite:'リアルタイム位置測位システム(RTLS)とは? ::・ オブ・でブログ',

  ogUrl : 'https://orbro.io/jp/blog/rtls',
  ogKey : '',
  ogImg : 'https://lh3.googleusercontent.com/fife/APg5EOa-nRYXA8PZImoRPlC90eAt55C_Yy5HojqGpcHjostLqtAF14MCSQ278cDyuN65UTXHiZHKvWeZoTRbQjbqQfGXnKhLe0Jzybk5GEEeDIBPuaQ2yJMVTE7cYE4ybvDVweuPcGID5jW-Km3DtdqhciBpUOpej1uGnUdDTETQFhnYEqhziXT9YHAFI273KfzuCNJ_uUqla7WVrXuO-L-JB9VOb02pjgn9OBX7ABY94YhcQuq6a-Ab-nBcHbSmBNGXO1A8mMU-tX8hUz0u8674fbuG1dG0s39XddJNEeATt4PPsUeHudjCnqM1mN5HYXmvKTbQDEwzHBUET0GnnPpP4qVOG863atiB02qL8oopfM9EARdQjyJvxwLzBI1I9gkPm8wG4--IG7ViMVK4wRq79qmHgONSyFMJoqVcMChZeB701Ly6tordATCjgSlwZmG4O0I9W-G0ngTMbYP3AFihY2RPoQic3cTW_4jhftk7gMEPACbeZIh6jokwFH2KqMxpAVFKgew8f6Xr5lEiMx1C32laNCJfgRS6Xcnp4Oz68hKxcpR_Fn2nHamfrquJVPM7rKuEcnfndeSOs3wrBpMk-FMkx3hgt1QqB4LW0OLmWNWl5ps3dhN2NItej8os9Zeh_2wcCMnFaM_hbDj-UrbDNl7QDg_oGk9Etqxc2xrfS1yM5uMP78VIHwgPqrsHx6RqMEtgLZFjVCRBhr_n61ELA0YFi3gN-ybLRz3qBXMpkAq9iGl79fwmZuKwVEMnOvMPMsGpxAwM-c2O_WDEF4Ux-6lUxX7d9BGAPDPSwRvcwfF8rfLhEnz_wpeT-Os5mApgdVujb0fYri1b7J9ghi54_nZCyDPci8vn-GpyhH0k6Y4b_g_m723hFbaw1OfNPXx1uc-riT8pR82xvGhJ_EtOPsWIXtaEtiljYneEBpDa24VRkJt5afbOwE99dwRbNKrrlPJc-uZBNlNy9NsH8_2tYFjt1fi2WO6DmDukQqiW3eiYKAY8rINaMN4i38u5wJT1AVlykMVMcqtcugjpg3MBh066wvi5rSKgh-P-2H7qVk58IrARg3z24QXHaA4KPkicsJEFI5I11-x0daCC5h3lo0BV-grpGI7fGDWd_eOyj76t509E6BIPpx6DQ3B_TawRKRHGCRXdagn5iJy66zrQfuaHi78tKYqs_N8Noa8_Un3XstK2nD_Y86r-SmsLonEhHAZFoCJ-yv3YbRA_fVz1QIDIxBNdfifkvLjy6SlgtRb84_XzUPKjcMBalkMWrjzOSWYvShQ8OHTopeZK1HJdDLBzbdi2a7sTKpULhRBcWWDzLkgDrdgQHPsc_gkq9ZnisEl3GNOElWsbItVNyDdeXriH5YdSibObkZStczC8FKOdKf1urhaY95eEUrEgFKtTDL44ZXtLgM7KbxUrLqXmp8_ZZT-IPBJss-j3ydlHfcbCQ2Vr0eXK_Alu4os65IyR3hgGYmYcmtci14dWMSKJjZmyQ6LqBV9bwNmfQxcm2CqnImGEdAVbfpHuy1tcwaJ4aZq8X6K4q-7Np--NMO-2u-ULgFP8OfGDSLgEvAfn5JOyig=w2059-h1216',
  ogType : 'website',

  twitterCard : '',
  twitterTitle : '',
  twitterDesc : '',
  
  title:'リアルタイム位置測位システム(RTLS)とは?',
  date:'2023-04-17',
  tag1:'#位置測位',
  tag2:'#RTLS',
  tag3:'#UWB',
  tag4:'#BLE',

    
   
  rtls: {
    title:"RTLS技術とは何ですか？",
    desc:"RTLS(Real-time Location Systems)とは、リアルタイムの位置測位システムで、無線通信、RFID(Radio Frequency Identification)、GPS(Global Positioning System)、BLE、UWBなど様々な技術を活用して開発された位置測位技術です。 <br/><br/>RTLS技術は物体、人などをリアルタイムで測位し、位置情報を収集·処理してこれを活用することができます。 これにより物流、製造、建設、小売など多様な産業分野でより正確で効率的な生産管理と物流サービスを提供できます。 <br/><br/>RTLS技術は各産業分野別に多様な用途で活用されます。 製造分野では生産工程内の装備や製品の位置測位、物流分野では商品の在庫管理および流通測位、建設分野では工事現場での安全管理、装備および物資測位などが可能です。 RTLSシステムは、会社が固有の空間に配置され、長距離で資産を測位するよりは、プロセスをモニタリングし改善することを目標としています。<br/><br/>RTLSには3つの主要要素があります。",
  },

  realtime: {
    title : '1.リアルタイム測位',
    desc:"RTLS技術は資産の位置情報をリアルタイムで把握し、該当資産が全体ライフサイクルの間どこに位置しているかをより正確に把握できるようにします。 これは製品生産ラインから移動する製品、工場内部の工具、倉庫に到着する原材料、車両位置、従業員位置などほぼすべてをタグして測位できます。 これにより、企業は資産位置に対するより体系的な監視と管理が可能となり、生産ライン管理、物流サービス、安全管理など様々な分野で効果的に活用することができます。",
  },

  predict: {
    title:"2.傾向及び例すなわち",
    desc:"資産の位置と動きを測定できるようになれば、プロセスを把握して簡単に回避できるエラー、不要な段階、リソース不足、従業員の異常な行動などをより容易に把握できます。 これにより生産ライン、物流、安全管理など様々な分野で起こりうる問題点を早期に把握し、より効果的な管理が可能となります。",
  },

  geo: {
    title:"3.ジオフェンシング",
    desc:"3次元空間における仮想境界を定義することは、従業員の安全保護、汚染防止、セキュリティなど様々な分野で活用されます。 これにより、危険地域から従業員を保護し、汚染を防止し、セキュリティを強化するなど、様々な適用分野があります。",
  },

  howItWorks:"RTLSはどのように動作しますか？",

  core: {
    title:"コアコンポーネント",
    desc:"RTLSシステムはすべて送信機、受信機、データを統合して位置を分析するソフトウェアの3つの要素で構成されています。 各RTLS プロバイダーは、彼らの技術について少しずつ異なる用語を使用し、彼ら固有の販売ポイントに重点を置きます。 以下は、これらのコア システム コンポーネントを一般化したものです。",
  },


  send: {
    title:"送信機",
    desc:`RTLSにおいて送信機とは、主にタグまたは受信機と接続されている機器のことです。 このデバイスは、オブジェクトや個人を識別し、位置情報を受信機に送信します。 送信機は通常、無線技術を使用して動作し、技術によってサイズとパフォーマンスが異なります。 送信機は物体に取り付けることも、個人や動物に着用することもできます。 一部の機種は電源が必要ない"passive"送信機を使用し、これらの送信機は近距離RFID技術を使用します。 他の機種では電源が必要な"active"送信機を使用し、これらの送信機は一般的にBluetooth低エネルギー(BLE)やUltra-Wideband(UWB)などの無線技術を使用します。 また、GPSタグも送信機として使用することができます。`,
  },
  rfid: {
    title : '1.RFID Tags',
    desc: "最も一般的なタグの 1 つで、パッシブ（つまりバッテリー電源が必要ない）で動作し、ほぼすべてのものに取り付けて資産を識別するために使用されます。",
  },


  ble: {
    title : '2.BLE Tags',
    desc:"最も普遍化された無線通信の一つであるBLE信号を発信する送信機である。 ほとんどのMobile機器でも動作するため汎用性は広いですが、UWBよりは精度が低いです。",
  },


  uwb: {
    title : '3. UWB Tags',
    desc:"一般的にバッテリー電源が必要なUWB信号を発信し、UWB受信機から受信します。 信号は非常に短いですが、広帯域周波数帯域を使用して低電力消費で非常に正確な位置データを提供します。",
  },


  smart: {
    title : '4. Smart Devices',
    desc: "様々なスマートデバイスが送信機として動作でき、携帯電話が最も代表的な例です。 BLEとGPS方式の両方を使用することができ、最近UWBが普及していくにつれ、一部機種でUWBを利用した測位をサポートします。",
  },


  gps: {
    title : '5. GPS Tags',
    desc: 'GPSタグは衛星を使って位置を把握します。 しかし、可視性の良い屋外環境でのみ動作し、追加のインフラストラクチャは必要ありません。 GPSタグはUWBタグより精度が低く、電力消費が相対的に多いです。 しかし、リアルタイムキネマティックGPSを追加してメインGPS信号を補正することで精度をセンチ単位で向上させることができます。',
  },


  receive: {
    title:"受信機",
    desc: "使用するタグの種類によって、タグを測位するために使用される受信機はさまざまです。 単純なパッシブRFIDタグでは十分でない、より複雑な室内環境ではアクティブRFID、Bluetooth Low Energy(BLE)またはUltra-Wideband(UWB)技術を使用することができます。 <br/><br/>重要な資産にタグを付け、物理的空間（工場、飛行機ヘリ倉庫、オフィスなど）周辺に受信機を配置することで、受信機はいつでも各資産の位置を決定し、この情報を関連ソフトウェア/視覚化システムに伝達することができます。 これらの受信機は通常、電源源とネットワーク（有線または無線で）に直接接続されます。",
  },


  software: {
    title : 'Software',
    desc:"RTLS技術にはセンサーとタグのようなハードウェアで実行されるファームウェアと位置データを解析する外部アプリケーション、そして外部アプリケーションに接続するミドルウェアを含む様々なソフトウェアシステムが使用されます。 つまり、これらのソフトウェアが一緒に作動してRTLSシステムが動作することになります。 <br/><br/>その中でRTLS技術を活用しようとする企業に最も関心があるのは外部アプリケーションのソフトウェアです。 このソフトウェアはRTLSと相互作用し、それから利益を得る方法を決定します。 どの産業に属するかによって、アプリケーション ソフトウェアは大きく異なる場合があります。 多くのRTLS企業は、企業の全体的な概要を最適化し、簡単なインサイトを提供するために設計されたカスタマイズソフトウェアアプリケーションを提供しています。 <br/><br/>RTLSシステムにおいて視覚化は通常核心的な役割を果たし、RTLSソフトウェアソリューションを選択する際に考慮すべき要素としては次のようなものがあります。 <br/><br/>平面図と領域マッピング - ソフトウェアが実際の平面図を正確かつ蓄積度であるため、大きさで反映できるか？ <br/>ソフトウェアの実用性 - すばらしい視覚化とともに、ユーザーの目的に合った必須機能を含んでいるか？ <br/>品質レポート - 即時インサイトを得るための分析および報告機能が存在するか？ <br/> オンプレミスまたはクラウド - 最適な方法でソフトウェアをホスティングするオプションがあるか？ <br/> API接続 - ソフトウェアがAPIを介して既存のビジネスシステムやデータベースと接続できるか？ <br/>拡張性 - このソフトウェアはビジネスが成長するにつれて拡張でき、位置データストリームが収集される間、ボトルネック現象なく動作することが立証されたか？<br/>サポートとトレーニング - このソリューションを開始するのにどれだけ簡単か、そして重要なミッションを担当するアプリケーションに対するサポートがうまくいくか?",
  },

  
  conclusion: {
    title:"RTLS技術の使用事例は何ですか？",
    desc:"RTLS技術に対する認識が高まり、この技術を適用できる産業がますます明確になっています。 代表的な例は以下の通りです。",
  },

  advantage:{
    safety:{
      title:"建設現場の安全管理",
      desc:"作業者と建設装備、材料の位置と移動経路をリアルタイムで測位して危険区域や行動を感知し、作業者に警告を送って事故を予防します。",
    },
    assets:{
      title:"物流倉庫資産測位",
      desc:"位置測位技術は資産の位置をリアルタイムで把握でき、作業者が資産の位置を探すのにかかる時間と労力を減らすことができます。 これは作業効率を向上させ、在庫の移動経路を最適化することで物流プロセスの効率性を高めるのにも役立ちます。"
    },
    medical:{
      title:"病院医療機器及び患者測位",
      desc:"位置測位技術は資産の位置をリアルタイムで把握でき、作業者が資産の位置を探すのにかかる時間と労力を減らすことができます。 これは作業効率を向上させ、在庫の移動経路を最適化することで物流プロセスの効率性を高めるのにも役立ちます。"
    },
    monitor:{
      title:"リアルタイム生産工程モニタリング",
      desc:"メーカーや工場の製品生産過程で製品の位置、生産ラインの動き、作業者の位置などをリアルタイムで測位できるようにします。 リアルタイムで位置情報を把握して生産ラインの動きが円滑に行われるように支援し、工程に問題が発生した時に素早く対処できるよう支援します。 これにより工場の生産ラインを最適化し、製品生産過程の効率性を高め、生産品質を改善する上で大きな役割を果たします。",
    },
    visitor:{
      title:"展示場訪問者分析",
      desc:"博物館、展示館、リテール売り場などで訪問客の時間帯別共感占有率を分析することができます。 これにより訪問者の移動経路、訪問頻度、滞在時間、人気のある展示物などの情報を把握することができ、これを土台に展示物や商品の位置や配置を調整して訪問者の満足度を高めるのに活用します。",
    },

    label:"RTLS技術は自動車、航空宇宙、国防、メンテナンス/修理/運営、公共交通機関、倉庫および物流、医療など様々な産業でRTLS技術を活用してより良い効率性と安全性を追求しています。 RTLS技術は、企業の競争力を強化する上で非常に重要です。 RTLSを使えば時間を節約し、労働力を削減し、在庫管理や部品測位などをより効率的に管理できます。 またRTLSは作業者の安全を改善し、危険要素を減らすのに役立ちます <br/><br/>RTLS技術は、今後ほとんどの産業分野で高い水準の収益性と効率性を追求する企業にとって必須な技術の一つです。",
  },

  share:"文章が気に入りましたか？ <br/>共有する",


    link : {
      page : 'rtls',
      numb : '2',
      product : [
        {
          text : productPurchase.purchase.worker.workerTracking.title,
          title : productPurchase.purchase.worker.workerTracking.title,
          serial : productPurchase.purchase.worker.workerTracking.serial,
          desc: 'UWB端末を作業者または装備に付着し、リアルタイムで位置測位ができる製品です。',
          img : productImg.product.workerTracking.thumbnail
        },
        {

        }

      ],
      solution : [
        {
          img : constructionAsset.thumb,
          data : 'constructionAsset',
          link : '/jp/enterprise/construction/asset'
        }, 
        {
          img : constructionSafety.thumb,
          data : 'constructionSafety',
          link : '/jp/enterprise/construction/safety'
        },
        {
          img : logisticsAsset.thumb,
          data : 'logisticsAsset',
          link : '/jp/enterprise/logistics/asset'
        }
      ]

    }

  }